import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountCoupons';

const AccountCouponsSuspense = dynamic(() => import('./AccountCoupons'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicAccountCoupons(props: Props) {
	return <AccountCouponsSuspense {...props} />;
}
DynamicAccountCoupons.displayName = 'DynamicAccountCoupons';
